(() => {
  'use strict';


  const STORAGE_KEY =
    'applianceBarnMultiBuyQuote';

  const UPDATE_EVENT =
    'multi-buy-quote:updated';


  const SALESFORCE_URL =
    'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00Dd3000008VjM2';

  const SALESFORCE_ORG_ID =
    '00Dd3000008VjM2';


  const SALESFORCE_FIELDS = {

    enquiryType:
      '00Nd300000CZUvZ',

    productsRequested:
      '00Nd300000CZUxB',

    requiredDeliveryDate:
      '00Nd300000CZUyn',

    projectValue:
      '00Nd300000CZV21'

  };


  function readQuote() {

    if (
      window.MultiBuyQuote &&
      typeof
        window.MultiBuyQuote.read ===
        'function'
    ) {

      return (
        window.MultiBuyQuote.read() ||
        []
      );

    }


    try {

      const stored =
        localStorage.getItem(
          STORAGE_KEY
        );


      if (!stored) {
        return [];
      }


      const parsed =
        JSON.parse(
          stored
        );


      return Array.isArray(
        parsed
      )
        ? parsed
        : (
            Array.isArray(
              parsed?.items
            )
              ? parsed.items
              : []
          );


    } catch (error) {

      console.error(
        'Unable to read quote.',
        error
      );


      return [];

    }

  }


  function saveQuote(
    items
  ) {

    if (
      window.MultiBuyQuote &&
      typeof
        window.MultiBuyQuote.save ===
        'function'
    ) {

      window.MultiBuyQuote.save(
        items
      );

      return;

    }


    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(items)
    );


    document.dispatchEvent(
      new CustomEvent(
        UPDATE_EVENT,
        {
          detail: {
            items
          }
        }
      )
    );

  }


  function escapeHtml(
    value
  ) {

    return String(
      value || ''
    )
      .replaceAll(
        '&',
        '&amp;'
      )
      .replaceAll(
        '<',
        '&lt;'
      )
      .replaceAll(
        '>',
        '&gt;'
      )
      .replaceAll(
        '"',
        '&quot;'
      )
      .replaceAll(
        "'",
        '&#039;'
      );

  }


  function formatMoney(
    pence
  ) {

    return new Intl
      .NumberFormat(
        'en-GB',
        {
          style:
            'currency',

          currency:
            'GBP'
        }
      )
      .format(
        Number(
          pence || 0
        ) / 100
      );

  }


  function getItemQuantity(
    item
  ) {

    return Math.max(
      1,
      Number(
        item.quantity ||
        1
      )
    );

  }


  function getServices(
    item
  ) {

    return Array.isArray(
      item.services
    )
      ? item.services
      : [];

  }


  function isPoaProduct(
    item
  ) {

    return (
      Number(
        item.price ||
        0
      ) === 0
    );

  }


  function isPriceRequest(
    items
  ) {

    if (
      items.length !==
      1
    ) {

      return false;

    }


    return (
      items[0]
        .priceRequest ===
        true ||
      isPoaProduct(
        items[0]
      )
    );

  }


  function calculateQuoteTotals(
    items
  ) {

    let totalQuantity =
      0;

    let pricedTotal =
      0;

    let hasPoa =
      false;


    items.forEach(
      item => {

        const quantity =
          getItemQuantity(
            item
          );


        const price =
          Number(
            item.price ||
            0
          );


        totalQuantity +=
          quantity;


        if (
          price > 0
        ) {

          pricedTotal +=
            price *
            quantity;

        } else {

          hasPoa =
            true;

        }

      }
    );


    return {

      totalQuantity,

      pricedTotal,

      hasPoa

    };

  }


  function getDisplayTotal(
    items
  ) {

    if (
      !items.length
    ) {

      return '£0.00';

    }


    const totals =
      calculateQuoteTotals(
        items
      );


    if (
      isPriceRequest(
        items
      )
    ) {

      return 'Price on request';

    }


    if (
      totals.hasPoa
    ) {

      if (
        totals.pricedTotal >
        0
      ) {

        return (
          `${formatMoney(
            totals.pricedTotal
          )} + POA`
        );

      }


      return 'Price on request';

    }


    return formatMoney(
      totals.pricedTotal
    );

  }


  function getPageElements(
    page
  ) {

    return {

      itemsContainer:
        page.querySelector(
          '[data-quote-items]'
        ),

      emptyState:
        page.querySelector(
          '[data-quote-empty]'
        ),

      formPanel:
        page.querySelector(
          '[data-quote-form-panel]'
        ),

      form:
        page.querySelector(
          '[data-quote-form]'
        ),

      message:
        page.querySelector(
          '[data-quote-message]'
        ),

      submitButton:
        page.querySelector(
          '[data-quote-submit]'
        ),

      productLines:
        page.querySelector(
          '[data-premium-quote-lines]'
        ),

      totalQuantity:
        page.querySelector(
          '[data-premium-quote-quantity]'
        ),

      totalValue:
        page.querySelector(
          '[data-premium-quote-total]'
        )

    };

  }


  function setText(
    element,
    text
  ) {

    if (element) {

      element.textContent =
        text;

    }

  }


  function updatePageWording(
    page,
    items
  ) {

    if (
      !items.length
    ) {

      return;

    }


    const priceRequest =
      isPriceRequest(
        items
      );


    const heroEyebrow =
      page.querySelector(
        '.multi-buy-quote__hero .multi-buy-quote__eyebrow'
      );


    const heroTitle =
      page.querySelector(
        '.multi-buy-quote__title'
      );


    const heroIntro =
      page.querySelector(
        '.multi-buy-quote__intro'
      );


    const benefits =
      page.querySelectorAll(
        '.multi-buy-quote__benefit'
      );


    const selectionLabel =
      page.querySelector(
        '.multi-buy-quote__section-header .multi-buy-quote__section-label'
      );


    const selectionTitle =
      page.querySelector(
        '.multi-buy-quote__section-title'
      );


    const continueShopping =
      page.querySelector(
        '.multi-buy-quote__continue'
      );


    const adviceTitle =
      page.querySelector(
        '.multi-buy-quote__advice h3'
      );


    const adviceCopy =
      page.querySelector(
        '.multi-buy-quote__advice p'
      );


    const formLabel =
      page.querySelector(
        '.multi-buy-quote__form-header .multi-buy-quote__section-label'
      );


    const formTitle =
      page.querySelector(
        '.multi-buy-quote__form-title'
      );


    const formIntro =
      page.querySelector(
        '.multi-buy-quote__form-intro'
      );


    const summaryRows =
      page.querySelectorAll(
        '.multi-buy-quote__summary-row'
      );


    const summaryNote =
      page.querySelector(
        '.multi-buy-quote__summary-note'
      );


    const submitButton =
      page.querySelector(
        '[data-quote-submit]'
      );


    const submitText =
      submitButton
        ? submitButton.querySelector(
            'span'
          )
        : null;


    const privacy =
      page.querySelector(
        '.multi-buy-quote__privacy'
      );


    if (
      priceRequest
    ) {

      setText(
        heroEyebrow,
        'Price & Availability'
      );


      setText(
        heroTitle,
        'Request Your Price'
      );


      setText(
        heroIntro,
        'Request our latest price and availability for this appliance. One of our specialists will review your enquiry and come back to you with our best personalised price.'
      );


      if (
        benefits[0]
      ) {

        setText(
          benefits[0]
            .querySelector(
              'span:last-child'
            ),
          'Latest personalised price'
        );

      }


      if (
        benefits[1]
      ) {

        setText(
          benefits[1]
            .querySelector(
              'span:last-child'
            ),
          'Expert appliance advice'
        );

      }


      if (
        benefits[2]
      ) {

        setText(
          benefits[2]
            .querySelector(
              'span:last-child'
            ),
          'Nationwide delivery available'
        );

      }


      setText(
        selectionLabel,
        'Your appliance'
      );


      setText(
        selectionTitle,
        'Selected appliance'
      );


      setText(
        continueShopping,
        'Add more appliances'
      );


      setText(
        adviceTitle,
        'Buying more than one appliance?'
      );


      setText(
        adviceCopy,
        'Add any other appliances you are considering and we’ll automatically turn your enquiry into a Multi-Buy Quote, allowing us to review your complete package and provide our best overall price.'
      );


      setText(
        formLabel,
        'Complete your enquiry'
      );


      setText(
        formTitle,
        'Get your personalised price'
      );


      setText(
        formIntro,
        'Complete your details below and one of our appliance specialists will contact you with our latest price and availability.'
      );


      if (
        summaryRows[0]
      ) {

        setText(
          summaryRows[0]
            .querySelector(
              'span'
            ),
          'Products requested'
        );

      }


      if (
        summaryRows[1]
      ) {

        setText(
          summaryRows[1]
            .querySelector(
              'span'
            ),
          'Total quantity'
        );

      }


      if (
        summaryRows[2]
      ) {

        setText(
          summaryRows[2]
            .querySelector(
              'span'
            ),
          'Price'
        );

      }


      setText(
        summaryNote,
        'We will confirm our latest personalised price and availability for this appliance.'
      );


      setText(
        submitText,
        'Request my price'
      );


      setText(
        privacy,
        'No payment is taken. We will review your enquiry and contact you with our latest personalised price and availability.'
      );


      return;

    }


    setText(
      heroEyebrow,
      'Personalised appliance packages'
    );


    setText(
      heroTitle,
      'Your Multi-Buy Quote'
    );


    if (
      benefits[0]
    ) {

      setText(
        benefits[0]
          .querySelector(
            'span:last-child'
          ),
        'Preferential package pricing'
      );

    }


    if (
      benefits[1]
    ) {

      setText(
        benefits[1]
          .querySelector(
            'span:last-child'
          ),
        'Dedicated appliance specialist'
      );

    }


    if (
      benefits[2]
    ) {

      setText(
        benefits[2]
          .querySelector(
            'span:last-child'
          ),
        'Coordinated delivery available'
      );

    }


    setText(
      selectionLabel,
      'Your selection'
    );


    setText(
      selectionTitle,
      'Selected appliances'
    );


    setText(
      continueShopping,
      'Continue shopping'
    );


    setText(
      adviceTitle,
      'Why request a multi-buy quote?'
    );


    setText(
      adviceCopy,
      'Purchasing several appliances together may allow us to provide enhanced package pricing, specialist advice and coordinated delivery across your project.'
    );


    setText(
      formLabel,
      'Complete your request'
    );


    setText(
      formTitle,
      'Tell us about your project'
    );


    setText(
      formIntro,
      'Complete the details below and one of our appliance specialists will contact you with your personalised quotation.'
    );


    if (
      summaryRows[0]
    ) {

      setText(
        summaryRows[0]
          .querySelector(
            'span'
          ),
        'Products selected'
      );

    }


    if (
      summaryRows[1]
    ) {

      setText(
        summaryRows[1]
          .querySelector(
            'span'
          ),
        'Total quantity'
      );

    }


    if (
      summaryRows[2]
    ) {

      setText(
        summaryRows[2]
          .querySelector(
            'span'
          ),
        'Website value'
      );

    }


    const totals =
      calculateQuoteTotals(
        items
      );


    setText(
      summaryNote,
      totals.hasPoa
        ? 'Products shown as Price on Request will be included when we prepare your personalised Multi-Buy package price.'
        : 'Your final quotation may include preferential multi-buy package pricing.'
    );


    setText(
      submitText,
      'Request my personalised quote'
    );


    setText(
      privacy,
      'No payment is taken. We will review your selection and contact you with your personalised quotation.'
    );

  }


  function createServicesMarkup(
    item
  ) {

    const services =
      getServices(
        item
      );


    if (
      !services.length
    ) {

      return '';

    }


    const rows =
      services
        .filter(
          service =>
            service &&
            service.name
        )
        .map(
          service => {

            const name =
              escapeHtml(
                service.name
              );


            const type =
              escapeHtml(
                service.type ||
                'service'
              );


            const price =
              escapeHtml(
                service.priceDisplay ||
                (
                  service.included
                    ? 'Included'
                    : ''
                )
              );


            return `
              <div
                class="ab-quote-service"
              >
                <span
                  class="ab-quote-service__type"
                >
                  ${type}
                </span>

                <span
                  class="ab-quote-service__name"
                >
                  ${name}
                </span>

                <strong
                  class="ab-quote-service__price"
                >
                  ${price}
                </strong>
              </div>
            `;

          }
        )
        .join('');


    if (!rows) {
      return '';
    }


    return `
      <div
        class="ab-quote-services"
      >
        <div
          class="ab-quote-services__heading"
        >
          Selected services
        </div>

        ${rows}
      </div>
    `;

  }


  function createProductMarkup(
    item
  ) {

    const variantId =
      escapeHtml(
        item.variantId
      );


    const title =
      escapeHtml(
        item.title ||
        'Product'
      );


    const variantTitle =
      escapeHtml(
        item.variantTitle ||
        ''
      );


    const sku =
      escapeHtml(
        item.sku ||
        ''
      );


    const image =
      escapeHtml(
        item.image ||
        ''
      );


    const productUrl =
      escapeHtml(
        item.url ||
        '#'
      );


    const quantity =
      getItemQuantity(
        item
      );


    const price =
      Number(
        item.price ||
        0
      );


    const priceDisplay =
      price > 0
        ? formatMoney(
            price
          )
        : 'Price on request';


    const imageMarkup =
      image
        ? `
          <a
            href="${productUrl}"
            class="multi-buy-quote__item-image-link"
          >
            <img
              class="multi-buy-quote__item-image"
              src="${image}"
              alt="${title}"
              loading="lazy"
            >
          </a>
        `
        : `
          <div
            class="multi-buy-quote__item-image"
            aria-hidden="true"
          ></div>
        `;


    const variantMarkup =
      variantTitle
        ? `
          <p
            class="multi-buy-quote__item-meta"
          >
            ${variantTitle}
          </p>
        `
        : '';


    const skuMarkup =
      sku
        ? `
          <p
            class="multi-buy-quote__item-meta"
          >
            Model: ${sku}
          </p>
        `
        : '';


    const servicesMarkup =
      createServicesMarkup(
        item
      );


    return `
      <article
        class="multi-buy-quote__item"
        data-quote-item
        data-variant-id="${variantId}"
      >

        ${imageMarkup}


        <div
          class="multi-buy-quote__item-details"
        >

          <h3
            class="multi-buy-quote__item-title"
          >
            <a
              href="${productUrl}"
            >
              ${title}
            </a>
          </h3>

          ${variantMarkup}

          ${skuMarkup}


          <p
            class="multi-buy-quote__item-meta"
          >
            ${priceDisplay}
          </p>


          ${servicesMarkup}

        </div>


        <div
          class="multi-buy-quote__item-actions"
        >

          <div
            class="multi-buy-quote__quantity"
            aria-label="Quantity for ${title}"
          >

            <button
              type="button"
              data-quote-decrease
              data-variant-id="${variantId}"
              aria-label="Decrease quantity"
            >
              −
            </button>


            <span
              data-quote-item-quantity
            >
              ${quantity}
            </span>


            <button
              type="button"
              data-quote-increase
              data-variant-id="${variantId}"
              aria-label="Increase quantity"
            >
              +
            </button>

          </div>


          <button
            type="button"
            class="multi-buy-quote__remove"
            data-quote-remove
            data-variant-id="${variantId}"
          >
            Remove item
          </button>

        </div>

      </article>
    `;

  }


  function renderPage(
    page
  ) {

    const elements =
      getPageElements(
        page
      );


    const items =
      readQuote();


    const totals =
      calculateQuoteTotals(
        items
      );


    if (
      elements.productLines
    ) {

      elements.productLines
        .textContent =
          String(
            items.length
          );

    }


    if (
      elements.totalQuantity
    ) {

      elements.totalQuantity
        .textContent =
          String(
            totals.totalQuantity
          );

    }


    if (
      elements.totalValue
    ) {

      elements.totalValue
        .textContent =
          getDisplayTotal(
            items
          );

    }


    if (
      !items.length
    ) {

      if (
        elements.itemsContainer
      ) {

        elements.itemsContainer
          .innerHTML =
            '';

      }


      if (
        elements.emptyState
      ) {

        elements.emptyState
          .hidden =
            false;

      }


      if (
        elements.formPanel
      ) {

        elements.formPanel
          .hidden =
            true;

      }


      return;

    }


    if (
      elements.emptyState
    ) {

      elements.emptyState
        .hidden =
          true;

    }


    if (
      elements.formPanel
    ) {

      elements.formPanel
        .hidden =
          false;

    }


    if (
      elements.itemsContainer
    ) {

      elements.itemsContainer
        .innerHTML =
          items
            .map(
              createProductMarkup
            )
            .join('');

    }


    updatePageWording(
      page,
      items
    );

  }


  function changeQuantity(
    variantId,
    amount
  ) {

    const items =
      readQuote();


    const item =
      items.find(
        quoteItem =>
          String(
            quoteItem.variantId
          ) ===
          String(
            variantId
          )
      );


    if (!item) {
      return;
    }


    item.quantity =
      Math.max(
        1,
        Number(
          item.quantity ||
          1
        ) +
        amount
      );


    saveQuote(
      items
    );

  }


  function removeItem(
    variantId
  ) {

    saveQuote(
      readQuote()
        .filter(
          item =>
            String(
              item.variantId
            ) !==
            String(
              variantId
            )
        )
    );

  }


  function getFieldValue(
    form,
    selector
  ) {

    const field =
      form.querySelector(
        selector
      );


    return field
      ? field.value.trim()
      : '';

  }


  function createHiddenField(
    form,
    name,
    value
  ) {

    const input =
      document.createElement(
        'input'
      );


    input.type =
      'hidden';

    input.name =
      name;

    input.value =
      value || '';


    form.appendChild(
      input
    );

  }


  function formatServicesForSalesforce(
    item
  ) {

    const services =
      getServices(
        item
      );


    if (
      !services.length
    ) {

      return [];

    }


    return services
      .filter(
        service =>
          service &&
          service.name
      )
      .map(
        service => {

          const type =
            service.type
              ? (
                  service.type
                    .charAt(0)
                    .toUpperCase() +
                  service.type
                    .slice(1)
                )
              : 'Service';


          const price =
            service.priceDisplay ||
            (
              service.included
                ? 'Included'
                : ''
            );


          return price
            ? `${type}: ${service.name} — ${price}`
            : `${type}: ${service.name}`;

        }
      );

  }


  function formatProductsForSalesforce(
    items
  ) {

    return items
      .map(
        (
          item,
          index
        ) => {

          const quantity =
            getItemQuantity(
              item
            );


          const price =
            Number(
              item.price ||
              0
            );


          const parts = [
            `${index + 1}. ${
              item.title ||
              'Product'
            }`
          ];


          if (
            item.variantTitle
          ) {

            parts.push(
              `Variant: ${item.variantTitle}`
            );

          }


          if (
            item.sku
          ) {

            parts.push(
              `Model: ${item.sku}`
            );

          }


          parts.push(
            `Quantity: ${quantity}`
          );


          if (
            price > 0
          ) {

            parts.push(
              `Website price: ${formatMoney(
                price
              )}`
            );

          } else {

            parts.push(
              'Website price: Price on request'
            );

          }


          const services =
            formatServicesForSalesforce(
              item
            );


          services.forEach(
            serviceLine => {

              parts.push(
                serviceLine
              );

            }
          );


          if (
            item.url
          ) {

            const absoluteUrl =
              item.url.startsWith(
                'http'
              )
                ? item.url
                : `${window.location.origin}${item.url}`;


            parts.push(
              `URL: ${absoluteUrl}`
            );

          }


          return parts.join(
            ' | '
          );

        }
      )
      .join(
        '\n'
      );

  }


  function submitToSalesforce(
    page,
    event
  ) {

    event.preventDefault();


    const elements =
      getPageElements(
        page
      );


    const form =
      elements.form;


    const items =
      readQuote();


    if (!form) {
      return;
    }


    if (
      !items.length
    ) {

      renderPage(
        page
      );

      return;

    }


    if (
      !form.reportValidity()
    ) {

      return;

    }


    const priceRequest =
      isPriceRequest(
        items
      );


    const enquiryType =
      priceRequest
        ? 'Price Request'
        : 'Multi-Buy Quote';


    const firstName =
      getFieldValue(
        form,
        '[name="firstName"]'
      );


    const lastName =
      getFieldValue(
        form,
        '[name="lastName"]'
      );


    const email =
      getFieldValue(
        form,
        '[name="email"]'
      );


    const phone =
      getFieldValue(
        form,
        '[name="phone"]'
      );


    const company =
      getFieldValue(
        form,
        '[name="company"]'
      ) ||
      'Private Customer';


    const postcode =
      getFieldValue(
        form,
        '[name="postcode"]'
      );


    const city =
      getFieldValue(
        form,
        '[name="city"]'
      );


    const requiredDate =
      getFieldValue(
        form,
        '[name="requiredDate"]'
      );


    const notes =
      getFieldValue(
        form,
        '[name="notes"]'
      );


    const totals =
      calculateQuoteTotals(
        items
      );


    /*
      Intentionally appliance website prices only.

      Service charges are listed in Products Requested
      but do not alter Salesforce Project Value.
    */

    const totalValueInPence =
      totals.pricedTotal;


    const productsRequested =
      formatProductsForSalesforce(
        items
      );


    const descriptionHeading =
      priceRequest
        ? 'Price Request'
        : 'Multi-Buy Quote request';


    const description = [
      descriptionHeading,
      '',
      productsRequested,
      '',
      notes
        ? `Project notes: ${notes}`
        : ''
    ]
      .filter(Boolean)
      .join(
        '\n'
      );


    const salesforceForm =
      document.createElement(
        'form'
      );


    salesforceForm.method =
      'POST';


    salesforceForm.action =
      SALESFORCE_URL;


    salesforceForm.style.display =
      'none';


    createHiddenField(
      salesforceForm,
      'oid',
      SALESFORCE_ORG_ID
    );


    createHiddenField(
      salesforceForm,
      'retURL',
      `${window.location.origin}/pages/multi-buy-quote-thank-you`
    );


    createHiddenField(
      salesforceForm,
      'lead_source',
      'Website'
    );


    createHiddenField(
      salesforceForm,
      'country_code',
      'GB'
    );


    createHiddenField(
      salesforceForm,
      'first_name',
      firstName
    );


    createHiddenField(
      salesforceForm,
      'last_name',
      lastName
    );


    createHiddenField(
      salesforceForm,
      'email',
      email
    );


    createHiddenField(
      salesforceForm,
      'phone',
      phone
    );


    createHiddenField(
      salesforceForm,
      'company',
      company
    );


    createHiddenField(
      salesforceForm,
      'city',
      city
    );


    createHiddenField(
      salesforceForm,
      'zip',
      postcode
    );


    createHiddenField(
      salesforceForm,
      SALESFORCE_FIELDS
        .enquiryType,
      enquiryType
    );


    createHiddenField(
      salesforceForm,
      SALESFORCE_FIELDS
        .productsRequested,
      productsRequested
    );


    createHiddenField(
      salesforceForm,
      SALESFORCE_FIELDS
        .requiredDeliveryDate,
      requiredDate
    );


    createHiddenField(
      salesforceForm,
      SALESFORCE_FIELDS
        .projectValue,
      (
        totalValueInPence /
        100
      ).toFixed(
        2
      )
    );


    createHiddenField(
      salesforceForm,
      'description',
      description
    );


    if (
      elements.submitButton
    ) {

      elements.submitButton
        .disabled =
          true;


      const buttonText =
        elements.submitButton
          .querySelector(
            'span'
          );


      if (
        buttonText
      ) {

        buttonText.textContent =
          priceRequest
            ? 'Sending your price request…'
            : 'Sending your quote request…';

      }

    }


    sessionStorage.setItem(
      'clearMultiBuyQuoteAfterSalesforce',
      'true'
    );


    document.body
      .appendChild(
        salesforceForm
      );


    salesforceForm.submit();

  }


  function injectServiceStyles() {

    if (
      document.getElementById(
        'ABQuoteServiceStyles'
      )
    ) {

      return;

    }


    const style =
      document.createElement(
        'style'
      );


    style.id =
      'ABQuoteServiceStyles';


    style.textContent = `
      .ab-quote-services {
        margin-top: 16px;
        padding-top: 14px;
        border-top: 1px solid #e7e2da;
      }

      .ab-quote-services__heading {
        margin-bottom: 8px;
        color: #59624a;
        font-size: 9px;
        font-weight: 800;
        letter-spacing: .11em;
        text-transform: uppercase;
      }

      .ab-quote-service {
        display: grid;
        grid-template-columns: 74px minmax(0, 1fr) auto;
        align-items: baseline;
        gap: 10px;
        padding: 4px 0;
        font-size: 11px;
        line-height: 1.45;
      }

      .ab-quote-service__type {
        color: #7b776f;
        font-size: 9px;
        font-weight: 700;
        text-transform: capitalize;
      }

      .ab-quote-service__name {
        color: #34312d;
      }

      .ab-quote-service__price {
        color: #111111;
        font-size: 10px;
        font-weight: 700;
        white-space: nowrap;
      }

      @media screen and (max-width: 650px) {
        .ab-quote-service {
          grid-template-columns: 62px minmax(0, 1fr);
        }

        .ab-quote-service__price {
          grid-column: 2;
        }
      }
    `;


    document.head.appendChild(
      style
    );

  }


  function initialisePage(
    page
  ) {

    if (
      !page ||
      page.dataset
        .quoteInitialised ===
        'true'
    ) {

      return;

    }


    page.dataset
      .quoteInitialised =
        'true';


    injectServiceStyles();


    renderPage(
      page
    );


    page.addEventListener(
      'click',
      event => {

        const increase =
          event.target.closest(
            '[data-quote-increase]'
          );


        if (increase) {

          changeQuantity(
            increase.dataset
              .variantId,
            1
          );

          return;

        }


        const decrease =
          event.target.closest(
            '[data-quote-decrease]'
          );


        if (decrease) {

          changeQuantity(
            decrease.dataset
              .variantId,
            -1
          );

          return;

        }


        const remove =
          event.target.closest(
            '[data-quote-remove]'
          );


        if (remove) {

          removeItem(
            remove.dataset
              .variantId
          );

        }

      }
    );


    const form =
      page.querySelector(
        '[data-quote-form]'
      );


    if (form) {

      form.addEventListener(
        'submit',
        event => {

          submitToSalesforce(
            page,
            event
          );

        }
      );

    }

  }


  function initialiseAllPages() {

    document
      .querySelectorAll(
        '[data-quote-page]'
      )
      .forEach(
        initialisePage
      );

  }


  document.addEventListener(
    UPDATE_EVENT,
    () => {

      document
        .querySelectorAll(
          '[data-quote-page]'
        )
        .forEach(
          renderPage
        );

    }
  );


  document.addEventListener(
    'shopify:section:load',
    initialiseAllPages
  );


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialiseAllPages
    );

  } else {

    initialiseAllPages();

  }

})();